<div class="usage-report-container" loading-spin [isLoading]="reloading" [loadingSize]="'big'">
    <div class="no-data" [style.display]="noDataStyle">
        <span>No Data Found</span>
    </div>
    <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-balham" [columnDefs]="columnDefs"
        [rowData]="rowData" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</div>